import { Check } from "lucide-react";

export default function StepProgress({ step }) {
  const steps = ["Academic", "Goals", "Contact"];

  return (
    <div className="flex items-center justify-between mb-10">
      {steps.map((label, index) => {
        const stepNumber = index + 1;
        const isActive = step === stepNumber;
        const isCompleted = step > stepNumber;

        return (
          <div key={label} className="flex-1 flex items-center">
            {/* Circle */}
            <div
              className={`w-9 h-9 rounded-full flex items-center justify-center border transition
                ${
                  isCompleted
                    ? "bg-primary text-white border-primary"
                    : isActive
                    ? "border-primary text-primary"
                    : "border-gray-300 text-gray-400"
                }`}
            >
              {isCompleted ? <Check size={16} /> : stepNumber}
            </div>

            {/* Label */}
            <span
              className={`ml-3 text-sm font-medium
                ${
                  isActive
                    ? "text-primary"
                    : isCompleted
                    ? "text-primary-dark"
                    : "text-gray-400"
                }`}
            >
              {label}
            </span>

            {/* Line */}
            {index !== steps.length - 1 && (
              <div className="flex-1 h-[1px] mx-4 bg-gray-200" />
            )}
          </div>
        );
      })}
    </div>
  );
}
